import React, { useState, useEffect, useContext } from "react";
import classes from "./Expenditure.module.css";
import { Row, Col, Form, Card, Button } from "react-bootstrap";
import { AutoComplete, Divider } from "rsuite";
import PermissionContext from "../../../Store/permission-context";
import ModalOkay from "../Modals/ModalOkay";
import DatePicker, {
  DateObject,
  getAllDatesInRange,
} from "react-multi-date-picker";

const Expenditure = () => {
  const [Expense, setExpense] = useState("");
  const [SingleDate, setSingleDate] = useState([]);
  const [Dates, setDates] = useState("");
  const [AllDates, setAllDates] = useState([]);
  const [DateCategory, setDateCategory] = useState("specific");
  const [Purpose, setPurpose] = useState("Select");
  const [Receiver, setReceiver] = useState("");
  const [SourceAccount, setSourceAccount] = useState("Cash");
  const PCtx = useContext(PermissionContext);
  const [ShowOkAlert, setShowOkAlert] = useState(false);
  const [Okmessage, setOkmessage] = useState("");
  const [Oktitle, setOktitle] = useState("");
  const [DisableButton, setDisableButton] = useState(true);
  const [AllTheExpenses, setAllTheExpenses] = useState([]);

  useEffect(() => {
    const getallexpenses = async () => {
      let AllExp = await PCtx.connectAxios("getregisteredexpenses.php", "");
      // console.log(AllExp);
      setAllTheExpenses(AllExp);
    };
    getallexpenses();
  }, []);

  useEffect(() => {
    if (Dates != "") {
      let SD = Dates.toString();
      console.log(SD);
      setSingleDate(SD);
    }
    // }
  }, [AllDates, Dates]);

  const setTheExpense = (e) => {
    let vl = e.target.value;

    if (!isNaN(vl)) {
      setExpense(vl);
      vl == "" ? setDisableButton(true) : setDisableButton(false);
    }
  };

  const GetTheExpenses = async (e) => {
    e.preventDefault();
    let Un = PCtx.Username;
    let expenses = {
      amount: Expense,
      getter: Receiver,
      reason: Purpose,
      account: SourceAccount,
      Username: Un,
      SelectedDate: SingleDate,
    };
    // console.log(expenses);
    let TheExpenses = await PCtx.connectAxios("saveexpenditure.php", expenses);

    if (TheExpenses.includes("Success")) {
      setOkmessage("Expenditure registered successfully.");
      setOktitle("SUCCESS!");
      setShowOkAlert(true);
    }
  };

  const nextOKEvent = () => {
    setShowOkAlert(false);
    window.location.reload();
  };

  return (
    <Row className="justify-content-around">
      <Col md={4} lg={4} sm={12} xs={12}>
        <Card>
          <Card.Header>
            <h3 className="text-cener">Expenditure Form</h3>
          </Card.Header>
          <Card.Body>
            <Form onSubmit={GetTheExpenses}>
              <Row>
                <hr />
                <Col md={12}>
                  <Form.Group className="" controlId="valval">
                    <Form.Label style={{ color: "brown", marginRight: "10px" }}>
                      Date of Expenditure:
                    </Form.Label>
                    <DatePicker
                      value={Dates}
                      editable={false}
                      style={{ border: "1px solid brown", height: "30px" }}
                      placeholder="Click me to open calendar!"
                      onChange={(dateObjects) => {
                        setDates(dateObjects);
                      }}
                      format="MMM DD, YYYY"
                      shadow={true}
                    />
                  </Form.Group>
                </Col>
                <hr />
                <Col md={12}>
                  <Form.Group className="" controlId="valval">
                    <Form.Label style={{ color: "brown" }}>
                      Amount Spent
                    </Form.Label>
                    <Form.Control
                      type="text"
                      value={Expense}
                      onChange={setTheExpense}
                      name="Expense"
                      style={{
                        backgroundColor: "White",
                        border: "1px solid brown",
                      }}
                    />
                  </Form.Group>
                </Col>
                <hr />
                <Col md={12}>
                  <Form.Label style={{ color: "brown" }}>
                    From which Account?
                  </Form.Label>
                  <Form.Select
                    value={SourceAccount}
                    onChange={(e) => setSourceAccount(e.target.value)}
                    style={{
                      backgroundColor: "White",
                      border: "1px solid brown",
                    }}
                  >
                    <option value="Cash">Cash Account</option>
                    <option value="POS">POS Account</option>
                    <option value="Transfer">Transfer Account</option>
                  </Form.Select>
                </Col>
                <hr />
                <Col md={12}>
                  <Form.Group className="" controlId="valval">
                    <Form.Label style={{ color: "brown" }}>
                      Given to:
                    </Form.Label>
                    <Form.Control
                      type="text"
                      value={Receiver}
                      onChange={(e) => setReceiver(e.target.value)}
                      name="Receiver"
                      style={{
                        backgroundColor: "White",
                        border: "1px solid brown",
                      }}
                    />
                  </Form.Group>
                </Col>
                <hr />
                <Col md={12}>
                  <Form.Group className="" controlId="valval">
                    <Form.Label style={{ color: "brown" }}>Purpose:</Form.Label>
                    <Form.Select
                      value={Purpose}
                      onChange={(e) => setPurpose(e.target.value)}
                      style={{
                        backgroundColor: "White",
                        border: "1px solid brown",
                      }}
                    >
                      <option value="">Select</option>
                      {AllTheExpenses.map((exp, index) => (
                        <option value={exp}>{exp}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <hr />
                <Col md={4} sm={4} xs={4} className="offset-4">
                  <Button
                    className="align-self-center"
                    variant="info"
                    type="submit"
                    disabled={DisableButton}
                  >
                    Save
                  </Button>
                </Col>
              </Row>
            </Form>
          </Card.Body>
        </Card>
      </Col>
      <ModalOkay
        message={Okmessage}
        okshow={ShowOkAlert}
        title={Oktitle}
        nextEvent={nextOKEvent}
      />
    </Row>
  );
};

export default Expenditure;
